// extracted by mini-css-extract-plugin
export default {"form":"styles_form__2vKgO","or":"styles_or__jglhf"};